import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const generateAiReturnFlow = unaryStreamRpc({
  name: "generateAiReturnFlow" as const,
  input: z.object({ prompt: z.string(), teamId: z.string() }),
  output: z.object({
    flow: z.any(),
    explanation: z.string(),
    warnings: z.array(z.string()),
    isComplete: z.boolean().optional(),
  }),
});
